import { classNames } from '@commenda/utils';
import React from 'react';

export type THelpText = {
  heading: string;
  text: string | null;
  orderNumber: number | null;
  jsx?: React.ReactNode;
};

const HelpTextItem = ({ item }: { item: THelpText }) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-start gap-3">
        {item.orderNumber && (
          <div
            className={classNames(
              'h-6 w-6 rounded-full bg-neutral-6 font-medium text-sm leading-[14px] tracking-[0.6px] flex items-center justify-center shrink-0'
            )}
          >
            {item.orderNumber}
          </div>
        )}
        <div
          className={classNames(
            'body-15-medium',
            item.orderNumber ? '' : 'ml-8'
          )}
        >
          {item.heading}
        </div>
      </div>
      {item.jsx ? (
        <div className="ml-8">{item.jsx}</div>
      ) : (
        <p className="body-15-regular  text-neutral-2 pl-10">{item.text}</p>
      )}
    </div>
  );
};

const HelpText = ({ helpText }: { helpText: THelpText[] }) => {
  return (
    <div className="flex flex-col gap-6">
      {helpText &&
        helpText.map((item) => (
          <HelpTextItem key={item.orderNumber + item.text} item={item} />
        ))}
    </div>
  );
};

export default HelpText;
